/* State module for itemperties information, shared across the app. If a page needs to store specific information, use a module for the given page. */

/**
 * Business function. register vuex Tab Module.
 * @param store the vuex store
 * @param namespace the attributes to search in
 * @param defaultNamespace
 * @param customGetters
 * @returns
 */
function registerTabModule({ store, namespace, tabs, customGetters }) {
  if (!Array.isArray(namespace) || !namespace.length) {
    throw new Error(`arg namespace must be an array, received : ${namespace}`);
  }
  if (!Array.isArray(tabs) || !tabs.length) {
    throw new Error(`arg tabs must be an array, received : ${tabs}`);
  } else if (store.hasModule(namespace)) {
    throw new Error(`Module ${namespace} already exist`);
  } else {
    store.registerModule(namespace, {
      namespaced: true,
      state: {
        currentNamespace: tabs[0],
        metaData: null,
      },
      getters: {
        currentNamespace: (state) => state.currentNamespace,
        metaData: (state) => state.metaData,
        ...customGetters,
      },
      mutations: {
        SET_CURRENT_NAMESPACE: (state, val) => {
          state.currentNamespace = val;
        },
        SET_METADATA: (state, val) => {
          state.metaData = val;
        },
      },
      actions: {
        setCurrentNamespace({ commit }, val) {
          if (!tabs.includes(val)) {
            throw new Error(
              `Could not set namespace cause ${val} not in ${tabs}`
            );
          } else {
            commit('SET_CURRENT_NAMESPACE', val);
          }
        },
        setData({ commit, dispatch }, { route, metadata }) {
          dispatch('setCurrentNamespace', route);
          commit('SET_METADATA', metadata);
        },
      },
    });
  }

  return { names: namespace, path: namespace.join('/') };
}

export default registerTabModule;
